import React, { useEffect, useState, useMemo, useRef } from 'react';
import {
  Container,
  Table,
  FormGroup,
  Label,
  Input,
  Row,
  Col,
  Card,
  CardBody,
  Spinner,
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Badge,
  InputGroup,
  InputGroupText,
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Pagination,
  PaginationItem,
  PaginationLink,
  Progress,
  Alert,
  Collapse
} from 'reactstrap'; 

// Importar cliente de Supabase desde el archivo supabaseClient 
import { supabase, formatDateFromSupabase } from '../services/supabaseClient';

// Cache global para almacenar los datos
let globalSEACENuevosCache = {
  data: null,
  totalRecords: 0,
  timestamp: null,
  isLoading: false
};

const CACHE_DURATION = 60 * 60 * 1000; // 60 minutos en milisegundos
const BATCH_SIZE = 500; // Reducido para mejor rendimiento

const SEACENuevos = ({ user }) => {
  // Estados principales
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [refreshing, setRefreshing] = useState(false);
  const [error, setError] = useState(null);
  const [dataLoaded, setDataLoaded] = useState(false);
  const [totalRecords, setTotalRecords] = useState(0);
  const [loadingProgress, setLoadingProgress] = useState(0);
  const [currentBatch, setCurrentBatch] = useState(0);
  const [totalBatches, setTotalBatches] = useState(0);
  
  // Estados para el sistema de revisión
  const [processosRevisados, setProcessosRevisados] = useState(new Set());
  const [loadingReviewed, setLoadingReviewed] = useState(false);
const [filtroEstadoRevision, setFiltroEstadoRevision] = useState('todos'); // 'todos', 'pendientes', 'revisados'
  
  // Estados para filtros
  const [entidadesSeleccionadas, setEntidadesSeleccionadas] = useState([]);
  const [filtroDescripcion, setFiltroDescripcion] = useState('');
  const [filtroTipoProceso, setFiltroTipoProceso] = useState('');
  const [filtroNomenclatura, setFiltroNomenclatura] = useState('');
  const [filtroObjeto, setFiltroObjeto] = useState('');
  const [filtroDepartamento, setFiltroDepartamento] = useState('');
  const [filtroProvincia, setFiltroProvincia] = useState('');
  const [filtroDistrito, setFiltroDistrito] = useState(''); // Nuevo filtro para distrito

  // Estados para dropdowns
  const [dropdownEntidad, setDropdownEntidad] = useState(false);
  const [searchEntidad, setSearchEntidad] = useState('');
  
  // Estados para ordenamiento y modal
  const [sortConfig, setSortConfig] = useState({ key: null, direction: 'asc' });
  const [selectedProcess, setSelectedProcess] = useState(null);
  const [modalOpen, setModalOpen] = useState(false);
  
  // Estados para paginación
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10); // Reducido para móvil
  
  // Estados para tooltips de descripción
  const [hoveredDescription, setHoveredDescription] = useState(null);
  const [tooltipPosition, setTooltipPosition] = useState({ x: 0, y: 0 });
  
  // Estados para vista móvil
  const [isFilterOpen, setIsFilterOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  
  // Referencias para dropdowns
  const dropdownEntidadRef = useRef(null);
  const hasInitialized = useRef(false);
// Agrega estos console.log al inicio del componente, después de los estados
console.log('=== DEBUG INICIAL ===');
console.log('User prop:', user);
console.log('User ID:', user?.id);
console.log('Loading reviewed:', loadingReviewed);
  // Detectar si es móvil
  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth < 768);
    };
    
    checkMobile();
    window.addEventListener('resize', checkMobile);
    
    return () => window.removeEventListener('resize', checkMobile);
  }, []);
const loadUserReviewedProcesses = async (userId) => {
  if (!userId) return;
  
  try {
    setLoadingReviewed(true);
    
    // Usar email como user_id
    const { data, error } = await supabase
      .from('user_reviewed_processes')
      .select('process_id')
      .eq('user_id', userId); // Aquí userId será el email

    if (error) throw error;

    const reviewedIds = new Set(data.map(item => item.process_id));
    setProcessosRevisados(reviewedIds);
    
  } catch (error) {
    console.error('Error cargando procesos revisados:', error);
  } finally {
    setLoadingReviewed(false);
  }
};
const toggleProcessReviewed = async (process, userId) => {
  console.log('=== TOGGLE PROCESS ===');
  console.log('Process:', process);
  console.log('User ID:', userId);
  
  if (!userId) {
    console.error('❌ No userId en toggle');
    return;
  }
  
  try {
    const processId = `${process.nomenclatura}-${process.descripcion_proceso}`;
    console.log('Process ID generado:', processId);
    
    const isCurrentlyReviewed = processosRevisados.has(processId);
    console.log('Está actualmente revisado:', isCurrentlyReviewed);
    
    if (isCurrentlyReviewed) {
      console.log('🗑️ Removiendo de revisados...');
      const { error } = await supabase
        .from('user_reviewed_processes')
        .delete()
        .eq('user_id', userId)
        .eq('process_id', processId);

      if (error) {
        console.error('❌ Error eliminando:', error);
        throw error;
      }
      
      console.log('✅ Eliminado de DB');
      setProcessosRevisados(prev => {
        const newSet = new Set(prev);
        newSet.delete(processId);
        console.log('✅ Estado actualizado - removido');
        return newSet;
      });
      
    } else {
      console.log('➕ Agregando a revisados...');
      const { data, error } = await supabase
        .from('user_reviewed_processes')
        .insert({
          user_id: userId,
          process_id: processId,
          nomenclatura: process.nomenclatura
        });

      if (error) {
        console.error('❌ Error insertando:', error);
        throw error;
      }
      
      console.log('✅ Insertado en DB:', data);
      setProcessosRevisados(prev => {
        const newSet = new Set([...prev, processId]);
        console.log('✅ Estado actualizado - agregado');
        return newSet;
      });
    }
    
  } catch (error) {
    console.error('❌ Error general:', error);
    alert(`Error: ${error.message}`);
  }
};

  // Función para verificar si un proceso está revisado
  const isProcessReviewed = (process) => {
    const processId = `${process.nomenclatura}-${process.descripcion_proceso}`;
    return processosRevisados.has(processId);
  };

  // Función para marcar todos los procesos como revisados
  const markAllAsReviewed = async () => {
    if (!user?.id) return;
    
    const procesosNoRevisados = dataAgrupada.filter(proceso => !isProcessReviewed(proceso));
    
    for (const proceso of procesosNoRevisados) {
      await toggleProcessReviewed(proceso, user.id);
    }
  };

  // Función para verificar si el cache es válido
  const isCacheValid = () => {
    if (!globalSEACENuevosCache.data || !globalSEACENuevosCache.timestamp) return false;
    const now = Date.now();
    return (now - globalSEACENuevosCache.timestamp) < CACHE_DURATION;
  };

  // Función para cargar desde cache o API
  const loadDataIfNeeded = async () => {
    if (isCacheValid() && !globalSEACENuevosCache.isLoading) {
      console.log('✅ Usando datos SEACE Nuevos desde cache', {
        registros: globalSEACENuevosCache.data.length,
        totalRecords: globalSEACENuevosCache.totalRecords
      });
      setData(globalSEACENuevosCache.data);
      setTotalRecords(globalSEACENuevosCache.totalRecords);
      setDataLoaded(true);
      return;
    }

    if (globalSEACENuevosCache.isLoading) {
      console.log('⏳ Datos SEACE Nuevos ya se están cargando...');
      if (globalSEACENuevosCache.data) {
        setData(globalSEACENuevosCache.data);
        setTotalRecords(globalSEACENuevosCache.totalRecords);
        setDataLoaded(true);
      }
      return;
    }

    await loadData();
  };

  // Efectos
useEffect(() => {
  if (!hasInitialized.current) {
    hasInitialized.current = true;
    loadDataIfNeeded();
    if (user?.email) { // Cambiar de user?.id a user?.email
      loadUserReviewedProcesses(user.email);
    }
  }
}, [user]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownEntidadRef.current && !dropdownEntidadRef.current.contains(event.target)) {
        setDropdownEntidad(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  // Función para obtener el conteo total de registros
  const getTotalCount = async () => {
    try {
      const { count, error } = await supabase
        .from('seace_news')
        .select('*', { count: 'exact', head: true });

      if (error) throw error;
      console.log(`📊 Total de registros en la tabla seace_news: ${count || 0}`);
      return count || 0;
    } catch (error) {
      console.error('Error al obtener conteo total:', error);
      return 0;
    }
  };

  // Función para cargar datos en lotes
  const loadAllDataInBatches = async (totalCount) => {
    const allData = [];
    const batches = Math.ceil(totalCount / BATCH_SIZE);
    setTotalBatches(batches);
    
    console.log(`📊 Iniciando carga de ${totalCount} registros en ${batches} lotes de ${BATCH_SIZE}`);

    for (let i = 0; i < batches; i++) {
      const start = i * BATCH_SIZE;
      const end = Math.min(start + BATCH_SIZE - 1, totalCount - 1);
      
      setCurrentBatch(i + 1);
      console.log(`🔄 Cargando lote ${i + 1}/${batches} (registros ${start} a ${end})`);
      
      try {
        const { data: batchData, error } = await supabase
          .from('seace_news')
          .select('*')
          .range(start, end)
          .order('created_at', { ascending: false });

        if (error) {
          console.error(`❌ Error en lote ${i + 1}:`, error);
          throw error;
        }
        
        if (batchData && batchData.length > 0) {
          allData.push(...batchData);
          console.log(`✅ Lote ${i + 1} cargado: ${batchData.length} registros (Total acumulado: ${allData.length})`);
        } else {
          console.warn(`⚠️ Lote ${i + 1} vacío`);
        }
        
        const progress = Math.round(((i + 1) / batches) * 100);
        setLoadingProgress(progress);
        
        if (i < batches - 1) {
          await new Promise(resolve => setTimeout(resolve, 50));
        }
        
      } catch (error) {
        console.error(`❌ Error crítico en lote ${i + 1}:`, error);
        throw error;
      }
    }

    console.log(`✅ Carga completa: ${allData.length} registros de ${totalCount} esperados`);
    return allData;
  };

  // Función de carga de datos
  const loadData = async (forceRefresh = false) => {
    if (globalSEACENuevosCache.isLoading && !forceRefresh) {
      console.log('⏸️ Carga SEACE Nuevos ya en progreso, saltando...');
      return;
    }

    setLoading(true);
    setRefreshing(true);
    setError(null);
    setLoadingProgress(0);
    setCurrentBatch(0);
    setTotalBatches(0);
    globalSEACENuevosCache.isLoading = true;

    try {
      console.log('🔄 Iniciando carga completa de datos SEACE Nuevos...');
      
      const totalCount = await getTotalCount();
      
      if (totalCount === 0) {
        console.log('📭 No hay registros en la tabla seace_news');
        setData([]);
        setTotalRecords(0);
        setDataLoaded(true);
        return;
      }

      const allData = await loadAllDataInBatches(totalCount);
      
      if (allData.length !== totalCount) {
        console.warn(`⚠️ Discrepancia en datos: esperados ${totalCount}, obtenidos ${allData.length}`);
      }
      
      console.log(`✅ Datos SEACE Nuevos cargados exitosamente: ${allData.length} registros`);
      
      globalSEACENuevosCache.data = allData;
      globalSEACENuevosCache.totalRecords = allData.length;
      globalSEACENuevosCache.timestamp = Date.now();
      
      setData(allData);
      setTotalRecords(allData.length);
      setDataLoaded(true);
      
    } catch (error) {
      console.error('❌ Error al cargar datos SEACE Nuevos:', error);
      setError(`Error al cargar los datos: ${error.message || 'Error desconocido'}. Por favor, intente nuevamente.`);
    } finally {
      setLoading(false);
      setRefreshing(false);
      setLoadingProgress(100);
      setCurrentBatch(0);
      setTotalBatches(0);
      globalSEACENuevosCache.isLoading = false;
    }
  };

  // Función para refrescar datos manualmente
  const refreshData = () => {
    console.log('🔄 Refrescando datos SEACE Nuevos manualmente...');
    globalSEACENuevosCache.data = null;
    globalSEACENuevosCache.timestamp = null;
    loadData(true);
  };

  // Función para agrupar datos por nomenclatura y descripción_proceso
  const dataAgrupada = useMemo(() => {
    console.log(`🔄 Agrupando ${data.length} registros nuevos...`);
    const grupos = new Map();
    
    data.forEach((item, index) => {
      const clave = `${item.id_procedimiento}`;
      
      if (!grupos.has(clave)) {
        grupos.set(clave, {
          created_at: item.created_at,
          entidad: item.entidad,
          tipo_proceso: item.tipo_proceso,
          num_proceso: item.num_proceso,
          nomenclatura: item.nomenclatura,
          departamento: item.departamento,
          provincia: item.provincia,
          distrito: item.distrito,
          objet: item.objeto || item.objet,
          moneda: item.moneda,
          fecha_convocatoria: item.fecha_convocatoria,
          fecha_presentacion_propuestas: item.fecha_presentacion_propuestas,
          descripcion_proceso: item.descripcion_proceso,
          fecha_inicio_participantes: item.fecha_inicio_participantes,
          fecha_fin_participantes: item.fecha_fin_participantes,
          items: [],
          total_items: 0,
          detalle_items_concat: ''
        });
      }
      
      const grupo = grupos.get(clave);
      
      if (item.detalle_item) {
        grupo.items.push({
          id_procedimiento: item.id_procedimiento,
          detalle_item: item.detalle_item,
          created_at: item.created_at
        });
      }
      
      grupo.total_items = grupo.items.length;
      grupo.detalle_items_concat = grupo.items
        .map(item => item.detalle_item)
        .filter(Boolean)
        .join('; ');
    });
    
    const resultado = Array.from(grupos.values());
    console.log(`✅ Agrupación completa: ${data.length} registros → ${resultado.length} procesos únicos nuevos`);
    return resultado;
  }, [data]);

  // Obtener valores únicos para filtros
  const entidadesUnicas = useMemo(() => {
    return Array.from(new Set(dataAgrupada.map(item => item.entidad).filter(Boolean))).sort();
  }, [dataAgrupada]);

  const tiposProcesoUnicos = useMemo(() => {
    return Array.from(new Set(dataAgrupada.map(item => item.tipo_proceso).filter(Boolean))).sort();
  }, [dataAgrupada]);

  const objetosUnicos = useMemo(() => {
    return Array.from(new Set(dataAgrupada.map(item => item.objet).filter(Boolean))).sort();
  }, [dataAgrupada]);

  const departamentosUnicos = useMemo(() => {
    return Array.from(new Set(dataAgrupada.map(item => item.departamento).filter(Boolean))).sort();
  }, [dataAgrupada]);

  const provinciasUnicas = useMemo(() => {
    return Array.from(new Set(dataAgrupada.map(item => item.provincia).filter(Boolean))).sort();
  }, [dataAgrupada]);

  // Nuevo: obtener distritos únicos
  const distritosUnicos = useMemo(() => {
    return Array.from(new Set(dataAgrupada.map(item => item.distrito).filter(Boolean))).sort();
  }, [dataAgrupada]);

  // Filtrar opciones basado en búsqueda
  const entidadesFiltradas = useMemo(() => {
    if (!searchEntidad.trim()) return entidadesUnicas;
    return entidadesUnicas.filter(entidad => 
      entidad.toLowerCase().includes(searchEntidad.toLowerCase())
    );
  }, [entidadesUnicas, searchEntidad]);

  // Datos filtrados
  const dataFiltrada = useMemo(() => {
    let filtered = dataAgrupada.filter((item) => {
      const coincideEntidad = entidadesSeleccionadas.length === 0 || 
        entidadesSeleccionadas.includes(item.entidad);
      
      const coincideDescripcion = filtroDescripcion.trim() === '' || 
        (item.descripcion_proceso || '').toLowerCase().includes(filtroDescripcion.toLowerCase());
      
      const coincideTipoProceso = filtroTipoProceso === '' || 
        (item.tipo_proceso || '').toLowerCase() === filtroTipoProceso.toLowerCase();

      const coincideNomenclatura = filtroNomenclatura.trim() === '' || 
        (item.nomenclatura || '').toLowerCase().includes(filtroNomenclatura.toLowerCase());

      const coincideObjeto = filtroObjeto === '' || 
        (item.objet || '').toLowerCase() === filtroObjeto.toLowerCase();

      const coincideDepartamento = filtroDepartamento === '' || 
        (item.departamento || '').toLowerCase() === filtroDepartamento.toLowerCase();

      const coincideProvincia = filtroProvincia === '' || 
        (item.provincia || '').toLowerCase() === filtroProvincia.toLowerCase();

      // Nuevo filtro para distrito
      const coincideDistrito = filtroDistrito === '' || 
        (item.distrito || '').toLowerCase() === filtroDistrito.toLowerCase();

      // Filtro de procesos revisados
const coincideEstadoRevision = 
  filtroEstadoRevision === 'todos' || 
  (filtroEstadoRevision === 'pendientes' && !isProcessReviewed(item)) ||
  (filtroEstadoRevision === 'revisados' && isProcessReviewed(item));

      return coincideDepartamento && coincideProvincia && coincideDistrito &&
             coincideEntidad && coincideDescripcion && coincideTipoProceso && 
             coincideNomenclatura && coincideObjeto && coincideEstadoRevision;
    });

    // Aplicar ordenamiento
    if (sortConfig.key) {
      filtered.sort((a, b) => {
        const aValue = a[sortConfig.key] || '';
        const bValue = b[sortConfig.key] || '';
        
        if (sortConfig.key.includes('fecha') || sortConfig.key.includes('created_at')) {
          const aDate = new Date(aValue);
          const bDate = new Date(bValue);
          return sortConfig.direction === 'asc' ? aDate - bDate : bDate - aDate;
        }
        
        if (sortConfig.key === 'num_proceso' || sortConfig.key === 'total_items') {
          const aNum = Number(aValue) || 0;
          const bNum = Number(bValue) || 0;
          return sortConfig.direction === 'asc' ? aNum - bNum : bNum - aNum;
        }
        
        if (aValue < bValue) {
          return sortConfig.direction === 'asc' ? -1 : 1;
        }
        if (aValue > bValue) {
          return sortConfig.direction === 'asc' ? 1 : -1;
        }
        return 0;
      });
    }

    return filtered;
}, [dataAgrupada, entidadesSeleccionadas, 
    filtroDescripcion, filtroTipoProceso, filtroNomenclatura, 
    filtroObjeto, filtroDepartamento, filtroProvincia, filtroDistrito, // Agregado filtroDistrito
    sortConfig, filtroEstadoRevision, processosRevisados]);

  // Datos paginados
  const dataPaginada = useMemo(() => {
    const start = (currentPage - 1) * itemsPerPage;
    return dataFiltrada.slice(start, start + itemsPerPage);
  }, [dataFiltrada, currentPage, itemsPerPage]);

  const totalPages = Math.ceil(dataFiltrada.length / itemsPerPage);

  // Componente para estadísticas de revisión
  const ReviewStats = () => {
    const totalProcesos = dataAgrupada.length;
    const procesosRevisadosCount = dataAgrupada.filter(isProcessReviewed).length;
    const procesosPendientes = totalProcesos - procesosRevisadosCount;
    const porcentajeRevisado = totalProcesos > 0 ? Math.round((procesosRevisadosCount / totalProcesos) * 100) : 0;
    
    return (
      <div className="d-flex flex-wrap gap-2 align-items-center">
        <Badge color="success" style={{ fontSize: '11px', padding: '4px 8px' }}>
          ✅ {procesosRevisadosCount} Revisados
        </Badge>
        <Badge color="warning" style={{ fontSize: '11px', padding: '4px 8px' }}>
          📋 {procesosPendientes} Pendientes
        </Badge>
   
      </div>
    );
  };
const ReviewCheckbox = ({ process, user, className = "" }) => {
  const isReviewed = isProcessReviewed(process);
  
  // Usar email como identificador
  const userId = user?.email || user?.id || user?.uid;
  
  const handleClick = async () => {
    console.log('User email:', user?.email);
    console.log('User ID usado:', userId);
    
    if (!userId) {
      alert('Usuario no identificado - verifica la sesión');
      return;
    }
    
    await toggleProcessReviewed(process, userId);
  };
  
  return (
    <div className={`d-flex align-items-center ${className}`}>
      <Input
        type="checkbox"
        checked={isReviewed}
        onChange={handleClick}
        disabled={!userId}
        style={{
          transform: 'scale(1.2)',
          cursor: userId ? 'pointer' : 'not-allowed'
        }}
      />
      {isReviewed && (
        <Label 
          className="mb-0 text-success fw-bold ms-2"
          style={{ 
            cursor: 'pointer',
            fontSize: '12px',
            userSelect: 'none'
          }}
          onClick={handleClick}
        >
          Revisado
        </Label>
      )}
    </div>
  );
};
  // Funciones de utilidad
  const formatDate = (dateString) => {
    if (!dateString) return '-';
    try {
      const date = new Date(dateString);
      return date.toLocaleDateString('es-PE', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
        hour12: false,
        timeZone: 'America/Lima' ,
      }).replace(/(\d{2})\/(\d{2})\/(\d{4}),?\s*(\d{2}):(\d{2}):(\d{2})/, '$1-$2-$3 $4:$5:$6');
    } catch (error) {
      return '-';
    }
  };

  const handleSort = (key) => {
    let direction = 'asc';
    if (sortConfig.key === key && sortConfig.direction === 'asc') {
      direction = 'desc';
    }
    setSortConfig({ key, direction });
  };

  const clearFilters = () => {
    setEntidadesSeleccionadas([]);
    setFiltroDescripcion('');
    setFiltroTipoProceso('');
    setFiltroNomenclatura('');
    setFiltroObjeto('');
    setFiltroDepartamento('');
    setFiltroProvincia('');
    setFiltroDistrito(''); // Limpiar filtro de distrito
   setFiltroEstadoRevision('todos');
    setSortConfig({ key: null, direction: 'asc' });
    setSearchEntidad('');
    setCurrentPage(1);
  };

  const openModal = (process) => {
    setSelectedProcess(process);
    setModalOpen(true);
  };

  const closeModal = () => {
    setSelectedProcess(null);
    setModalOpen(false);
  };

  const getSortIcon = (key) => {
    if (sortConfig.key !== key) return '⇅';
    return sortConfig.direction === 'asc' ? '↑' : '↓';
  };

  const getTypeColor = (tipo) => {
    const colors = {
      'BIEN': 'primary',
      'SERVICIO': 'success',
      'OBRA': 'warning',
      'CONSULTORÍA': 'info',
      'BIENES': 'primary',
      'SERVICIOS': 'success',
      'OBRAS': 'warning',
      'CONSULTORIA': 'info'
    };
    return colors[tipo?.toUpperCase()] || 'secondary';
  };

  const getMonedaColor = (moneda) => {
    const colors = {
      'SOLES': 'success',
      'S/': 'success',
      'PEN': 'success',
      'DOLARES': 'primary',
      'USD': 'primary',
      'EUROS': 'warning',
      'EUR': 'warning'
    };
    return colors[moneda?.toUpperCase()] || 'secondary';
  };

  // Funciones para manejar tooltips de descripción
  const handleMouseEnterDescription = (event, description) => {
    const rect = event.target.getBoundingClientRect();
    setTooltipPosition({
      x: rect.left + rect.width / 2,
      y: rect.top - 10
    });
    setHoveredDescription(description);
  };

  const handleMouseLeaveDescription = () => {
    setHoveredDescription(null);
  };

  // Funciones para manejar dropdowns
  const createDropdownHandlers = (
    selectedItems,
    setSelectedItems,
    setDropdownOpen,
    searchValue,
    setSearchValue
  ) => ({
    toggle: (item, event) => {
      if (event) {
        event.preventDefault();
        event.stopPropagation();
      }
      setSelectedItems(prev => 
        prev.includes(item) 
          ? prev.filter(i => i !== item)
          : [...prev, item]
      );
    },
    selectAll: (allItems, event) => {
      if (event) {
        event.preventDefault();
        event.stopPropagation();
      }
      setSelectedItems(allItems);
    },
    clear: (event) => {
      if (event) {
        event.preventDefault();
        event.stopPropagation();
      }
      setSelectedItems([]);
    },
    getButtonText: (allItems) => {
      if (selectedItems.length === 0) return `📋 Todas`;
      if (selectedItems.length === 1) return `📋 ${selectedItems[0]}`;
      return `📋 ${selectedItems.length} seleccionadas`;
    }
  });

  const entidadHandlers = createDropdownHandlers(
    entidadesSeleccionadas,
    setEntidadesSeleccionadas,
    setDropdownEntidad,
    searchEntidad,
    setSearchEntidad
  );

  const CustomDropdown = ({ 
    isOpen, 
    toggle, 
    buttonText, 
    items, 
    filteredItems, 
    selectedItems, 
    searchValue, 
    setSearchValue, 
    handlers, 
    dropdownRef, 
    placeholder,
    icon = "📋"
  }) => (
    <div ref={dropdownRef} style={{ position: 'relative', zIndex: 1000 }}>
      <Dropdown 
        isOpen={isOpen} 
        toggle={() => {}}
        className="w-100" 
        direction="down"
      >
        <DropdownToggle 
          caret 
          className="form-select-modern w-100 d-flex justify-content-between align-items-center"
          onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
            toggle(e);
          }}
          style={{ 
            textAlign: 'left',
            backgroundColor: '#f8f9ba',
            border: '2px solid #e9ecef',
            borderRadius: '12px',
            padding: '12px 16px',
            fontSize: '14px',
            fontWeight: '500',
            transition: 'all 0.3s ease',
            boxShadow: '0 2px 4px rgba(0,0,0,0.05)',
            color: '#495057'
          }}
        >
          <span className="text-truncate">{buttonText}</span>
        </DropdownToggle>
        <DropdownMenu 
          className="w-100"
          style={{ 
            maxHeight: '350px', 
            overflowY: 'auto',
            border: '2px solid #e9ecef',
            borderRadius: '12px',
            boxShadow: '0 10px 30px rgba(0,0,0,0.15)',
            position: 'absolute',
            zIndex: 9999,
            backgroundColor: '#ffffff',
            minWidth: '100%',
            left: 0,
            right: 'auto',
            transform: 'none',
            marginTop: '4px'
          }}
        >
          <div 
            className="p-3 border-bottom bg-light" 
            onClick={(e) => {
              e.stopPropagation();
              e.preventDefault();
            }}
            onMouseDown={(e) => {
              e.stopPropagation();
              e.preventDefault();
            }}
          >
            <Input
              type="text"
              placeholder={placeholder}
              value={searchValue}
              onChange={(e) => {
                e.stopPropagation();
                setSearchValue(e.target.value);
              }}
              onKeyDown={(e) => {
                e.stopPropagation();
              }}
              onFocus={(e) => {
                e.stopPropagation();
              }}
              onClick={(e) => {
                e.stopPropagation();
                e.preventDefault();
              }}
              onMouseDown={(e) => {
                e.stopPropagation();
                e.preventDefault();
              }}
              onInput={(e) => {
                e.stopPropagation();
              }}
              onKeyUp={(e) => {
                e.stopPropagation();
              }}
              onBlur={(e) => {
                e.preventDefault();
              }}
              className="form-control-sm"
              style={{
                borderRadius: '8px',
                border: '1px solid #dee2e6',
                fontSize: '13px',
                color: '#495057'
              }}
              autoComplete="off"
              autoFocus={isOpen}
            />
          </div>
          
          <div className="p-2 border-bottom bg-light">
            <div className="d-flex justify-content-between">
              <Button
                color="link"
                size="sm"
                className="p-1 text-decoration-none fw-bold text-success"
                onClick={(e) => handlers.selectAll(items, e)}
                style={{ fontSize: '12px' }}
              >
                ✅ Seleccionar Todos
              </Button>
              <Button
                color="link"
                size="sm"
                className="p-1 text-decoration-none fw-bold text-danger"
                onClick={(e) => handlers.clear(e)}
                style={{ fontSize: '12px' }}
              >
                🗑️ Limpiar
              </Button>
            </div>
          </div>

          {filteredItems.length > 0 ? (
            filteredItems.map((item) => (
              <DropdownItem
                key={item}
                className="d-flex align-items-center justify-content-between py-2 px-3"
                onClick={(e) => handlers.toggle(item, e)}
                style={{ 
                  cursor: 'pointer',
                  fontSize: '13px',
                  transition: 'background-color 0.2s ease',
                  color: '#495057'
                }}
                toggle={false}
              >
                <span className="text-truncate me-2" style={{ fontWeight: '500', color: '#495057' }}>{item}</span>
                {selectedItems.includes(item) && (
                  <span className="text-success fw-bold">✓</span>
                )}
              </DropdownItem>
            ))
          ) : (
            <DropdownItem disabled>
              <span className="text-muted fst-italic">No se encontraron resultados</span>
            </DropdownItem>
          )}
          
          <div className="p-3 border-top text-center bg-light">
            <Button
              color="primary"
              size="sm"
              onClick={(e) => {
                e.stopPropagation();
                toggle();
              }}
              style={{
                borderRadius: '8px',
                fontWeight: '600',
                fontSize: '12px',
                padding: '8px 16px'
              }}
            >
              ✅ Aplicar Filtros
            </Button>
          </div>
        </DropdownMenu>
      </Dropdown>
    </div>
  );

  // Componente de paginación
  const PaginationComponent = () => {
    const getPageNumbers = () => {
      const pages = [];
      const maxPagesToShow = isMobile ? 3 : 5;
      
      if (totalPages <= maxPagesToShow) {
        for (let i = 1; i <= totalPages; i++) {
          pages.push(i);
        }
      } else {
        let startPage = Math.max(1, currentPage - Math.floor(maxPagesToShow / 2));
        let endPage = Math.min(totalPages, startPage + maxPagesToShow - 1);
        
        if (endPage - startPage + 1 < maxPagesToShow) {
          startPage = Math.max(1, endPage - maxPagesToShow + 1);
        }
        
        for (let i = startPage; i <= endPage; i++) {
          pages.push(i);
        }
      }
      
      return pages;
    };

    const pageNumbers = getPageNumbers();

    return (
      <div className="d-flex flex-column flex-md-row justify-content-between align-items-center mt-4 gap-3">
        <div className="d-flex flex-column flex-md-row align-items-center gap-3">
          <div className="text-muted fw-medium text-center" style={{ fontSize: isMobile ? '12px' : '14px' }}>
            Mostrando {((currentPage - 1) * itemsPerPage) + 1} a {Math.min(currentPage * itemsPerPage, dataFiltrada.length)} de {dataFiltrada.length} procesos nuevos
          </div>
          <div className="d-flex align-items-center gap-2">
            <Label className="text-muted fw-medium mb-0" style={{ fontSize: '13px' }}>Mostrar:</Label>
            <Input
              type="select"
              value={itemsPerPage}
              onChange={(e) => {
                setItemsPerPage(Number(e.target.value));
                setCurrentPage(1);
              }}
              style={{
                width: '80px',
                borderRadius: '8px',
                border: '1px solid #dee2e6',
                fontSize: '13px'
              }}
            >
              <option value={5}>5</option>
              <option value={10}>10</option>
              <option value={20}>20</option>
              <option value={50}>50</option>
            </Input>
          </div>
        </div>
        
        <Pagination className="mb-0" size={isMobile ? 'sm' : ''}>
          <PaginationItem disabled={currentPage === 1}>
            <PaginationLink 
              previous 
              onClick={() => setCurrentPage(currentPage - 1)}
              style={{
                borderRadius: '8px 0 0 8px',
                border: '1px solid #dee2e6',
                color: '#6c757d'
              }}
            />
          </PaginationItem>
          
          {pageNumbers.map(page => (
            <PaginationItem key={page} active={page === currentPage}>
              <PaginationLink 
                onClick={() => setCurrentPage(page)}
                style={{
                  border: '1px solid #dee2e6',
                  color: page === currentPage ? '#fff' : '#6c757d',
                  backgroundColor: page === currentPage ? '#0d6efd' : '#fff',
                  fontWeight: page === currentPage ? '600' : '500'
                }}
              >
                {page}
              </PaginationLink>
            </PaginationItem>
          ))}
          
          <PaginationItem disabled={currentPage === totalPages}>
            <PaginationLink 
              next 
              onClick={() => setCurrentPage(currentPage + 1)}
              style={{
                borderRadius: '0 8px 8px 0',
                border: '1px solid #dee2e6',
                color: '#6c757d'
              }}
            />
          </PaginationItem>
        </Pagination>
      </div>
    );
  };

  // Tooltip personalizado para descripciones
  const DescriptionTooltip = () => {
    if (!hoveredDescription) return null;

    return (
      <div
        style={{
          position: 'fixed',
          left: `${tooltipPosition.x}px`,
          top: `${tooltipPosition.y}px`,
          transform: 'translateX(-50%) translateY(-100%)',
          backgroundColor: '#343a40',
          color: 'white',
          padding: '12px 16px',
          borderRadius: '8px',
          fontSize: '13px',
          lineHeight: '1.4',
          maxWidth: '400px',
          zIndex: 10000,
          boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
          border: '1px solid #495057',
          fontWeight: '500'
        }}
      >
        {hoveredDescription}
        <div
          style={{
            position: 'absolute',
            top: '100%',
            left: '50%',
            transform: 'translateX(-50%)',
            width: 0,
            height: 0,
            borderLeft: '6px solid transparent',
            borderRight: '6px solid transparent',
            borderTop: '6px solid #343a40'
          }}
        />
      </div>
    );
  };

  // Componente de tarjeta móvil para cada proceso
  const MobileProcessCard = ({ proceso, index }) => (
    <Card 
      className={`mb-3 shadow-sm border-0 ${isProcessReviewed(proceso) ? 'border-success' : ''}`}
      style={{ 
        borderRadius: '16px',
        backgroundColor: isProcessReviewed(proceso) 
          ? '#f8fff8' 
          : (index % 2 === 0 ? '#ffffff' : '#f8f9fa'),
        borderLeft: isProcessReviewed(proceso) ? '4px solid #28a745' : 'none'
      }}
    >
      <CardBody className="p-3">
        {/* Header con estado de revisión */}
        <div className="d-flex justify-content-between align-items-center mb-2">
          <div className="d-flex gap-2">
            <Badge 
              color={getTypeColor(proceso.objet)}
              style={{
                fontSize: '11px',
                fontWeight: '600',
                padding: '4px 8px',
                borderRadius: '12px'
              }}
            >
              {proceso.objet || 'N/A'}
            </Badge>
            <Badge 
              color="success"
              style={{
                fontSize: '11px',
                fontWeight: '600',
                padding: '4px 8px',
                borderRadius: '12px'
              }}
            >
              {proceso.total_items} items
            </Badge>
          </div>
          
          {/* Checkbox de revisión */}
          <ReviewCheckbox 
            process={proceso} 
            user={user}
          />
        </div>
        
        <h6 className="fw-bold text-primary mb-1" style={{ fontSize: '14px' }}>
          {proceso.nomenclatura || 'Sin nomenclatura'}
        </h6>
        
        <p className="text-muted mb-2" style={{ fontSize: '12px', lineHeight: '1.4' }}>
          <strong>Entidad:</strong> {proceso.entidad || 'N/A'}
        </p>
        
        <p className="text-dark mb-2" style={{ fontSize: '13px', lineHeight: '1.4' }}>
          {proceso.descripcion_proceso ? 
            (proceso.descripcion_proceso.length > 100 ? 
              `${proceso.descripcion_proceso.substring(0, 100)}...` : 
              proceso.descripcion_proceso
            ) : 
            'Sin descripción'
          }
        </p>
        
        <div className="mb-2" style={{ fontSize: '12px' }}>
          <div className="d-flex justify-content-between text-muted">
            <span><strong>Ubicación:</strong></span>
            <span>{proceso.departamento}, {proceso.provincia}</span>
          </div>
        </div>
        
        <div className="mb-3" style={{ fontSize: '12px' }}>
          <div className="d-flex justify-content-between text-muted">
            <span><strong>Tipo:</strong></span>
            <Badge 
              color={getTypeColor(proceso.tipo_proceso)}
              style={{ fontSize: '10px', padding: '2px 6px' }}
            >
              {proceso.tipo_proceso || 'N/A'}
            </Badge>
          </div>
        </div>
        
        <div className="mb-3" style={{ fontSize: '11px', color: '#6c757d' }}>
          <div className="row g-1">
            <div className="col-6">
              <strong>F. Inicio:</strong><br />
              {formatDateFromSupabase(proceso.fecha_inicio_participantes)}
            </div>
            <div className="col-6">
              <strong>F. Fin:</strong><br />
              {formatDateFromSupabase(proceso.fecha_fin_participantes)}
            </div>
          </div>
        </div>
        
        <div className="d-flex justify-content-between align-items-center">
          <small className="text-muted">
            F. Presentación: {formatDateFromSupabase(proceso.fecha_presentacion_propuestas)}
          </small>
          <Button
            color="success"
            size="sm"
            onClick={() => openModal(proceso)}
            style={{
              borderRadius: '8px',
              fontWeight: '600',
              padding: '6px 12px',
              fontSize: '11px'
            }}
          >
            Ver Detalles
          </Button>
        </div>
      </CardBody>
    </Card>
  );

  return (
    <Container fluid className="py-2 px-2" style={{ backgroundColor: '#f8f9fa', minHeight: '100vh' }}>
      {/* Tooltip personalizado */}
      <DescriptionTooltip />
      
      {/* Header Superior */}
      <Card className="shadow-lg border-0 mb-3" style={{ borderRadius: '20px', background: 'linear-gradient(135deg, #28a745 0%, #20c997 100%)' }}>
        <CardBody className={`p-${isMobile ? '3' : '4'}`}>
          <Row className="align-items-center">
            <Col xs={8} md={8}>
              <div className="d-flex align-items-center mb-2">
                <div className="me-2" style={{ fontSize: isMobile ? '2rem' : '3rem' }}>
                  🆕
                </div>
                <div>
                  <h1 className="mb-1 fw-bold text-white" style={{ fontSize: isMobile ? '1.5rem' : '2.5rem' }}>
                    SEACE Nuevos
                  </h1>
                  <p className="mb-2 text-white-50" style={{ fontSize: isMobile ? '0.9rem' : '1.1rem' }}>
                    Últimas convocatorias publicadas
                    <Badge color="light" className="ms-2 text-success fw-bold" style={{ fontSize: '0.8rem' }}>
                      {dataFiltrada.length} convocatorias
                    </Badge>
                  </p>
                  {/* Estadísticas de revisión */}
                  {data.length > 0 && <ReviewStats />}
                </div>
              </div>
            </Col>
            <Col xs={4} md={4} className="text-end">
              <Button 
                color="light" 
                onClick={refreshData}
                disabled={loading}
                size={isMobile ? 'sm' : ''}
                style={{
                  borderRadius: '12px',
                  fontWeight: '600',
                  padding: isMobile ? '8px 12px' : '12px 24px',
                  fontSize: isMobile ? '12px' : '14px',
                  border: 'none',
                  boxShadow: '0 4px 12px rgba(255,255,255,0.3)'
                }}
              >
                {loading ? (
                  <>
                    <Spinner size="sm" className="me-1" />
                    {!isMobile && 'Cargando...'}
                  </>
                ) : (
                  <>
                    🔄 {!isMobile && 'Actualizar'}
                  </>
                )}
              </Button>
            </Col>
          </Row>
        </CardBody>
      </Card>

      {/* Alertas de error */}
      {error && (
        <Alert color="danger" className="mb-3" style={{ borderRadius: '12px' }}>
          <h6 className="alert-heading fw-bold">⚠️ Error de carga</h6>
          {error}
        </Alert>
      )}

      {/* Barra de progreso durante la carga */}
      {loading && (
        <Card className="mb-3" style={{ borderRadius: '12px' }}>
          <CardBody className="p-3">
            <div className="text-center mb-2">
              <small className="text-muted fw-medium">
                Cargando nuevos procesos... {loadingProgress}%
                {currentBatch > 0 && totalBatches > 0 && (
                  <span className="d-block">Lote {currentBatch} de {totalBatches}</span>
                )}
              </small>
              {totalRecords > 0 && (
                <small className="d-block text-muted">
                  Procesando {data.length} de {totalRecords} registros
                </small>
              )}
            </div>
            <Progress 
              animated 
              value={loadingProgress} 
              style={{ height: '8px', borderRadius: '4px' }}
              color="success"
            />
          </CardBody>
        </Card>
      )}

      {/* Mensaje cuando no hay datos pero no está cargando */}
      {!loading && data.length === 0 && !error && (
        <Card className="empty-data-card mb-3" style={{ borderRadius: '12px' }}>
          <CardBody className="text-center p-4">
            <div className="empty-data-content">
              <div className="empty-data-icon mb-3" style={{ fontSize: '3rem' }}>📭</div>
              <h5 style={{ fontSize: isMobile ? '1.2rem' : '1.5rem' }}>No hay procesos nuevos</h5>
              <p className="text-muted" style={{ fontSize: isMobile ? '0.9rem' : '1rem' }}>
                Haz clic en "Actualizar" para cargar los últimos procesos SEACE
              </p>
              <Button color="success" onClick={refreshData} size={isMobile ? 'sm' : ''}>
                🔄 Cargar Procesos
              </Button>
            </div>
          </CardBody>
        </Card>
      )}

      {/* Solo mostrar filtros y contenido si hay datos */}
      {data.length > 0 && (
        <>
          {/* Botón de filtros para móvil */}
          {isMobile && (
            <div className="mb-3">
              <Button
                color="primary"
                onClick={() => setIsFilterOpen(!isFilterOpen)}
                className="w-100 d-flex justify-content-between align-items-center"
                style={{
                  borderRadius: '12px',
                  fontWeight: '600',
                  padding: '12px 16px'
                }}
              >
                <span>🔍 Filtros de Búsqueda</span>
                <span>{isFilterOpen ? '⬆️' : '⬇️'}</span>
              </Button>
            </div>
          )}

          {/* Filtros */}
          <Collapse isOpen={!isMobile || isFilterOpen}>
            <Card className="shadow-sm border-0 mb-3" style={{ borderRadius: '16px' }}>
              <CardBody className="p-3">
                <div className="d-flex justify-content-between align-items-center mb-3">
                  <h6 className="mb-0 fw-bold text-dark d-flex align-items-center">
                    <span className="me-2" style={{ fontSize: '1.2rem' }}>🔍</span>
                    Filtros de Búsqueda
                  </h6>
                  <div className="d-flex gap-2">
                    {user?.id && (
                      <Button
                        color="outline-success"
                        size="sm"
                        onClick={markAllAsReviewed}
                        disabled={loadingReviewed}
                        style={{
                          borderRadius: '8px',
                          fontWeight: '600',
                          padding: '6px 12px',
                          fontSize: '11px'
                        }}
                      >
                        ✅ Marcar todos
                      </Button>
                    )}
                    <Button 
                      color="outline-danger" 
                      size="sm" 
                      onClick={clearFilters}
                      style={{
                        borderRadius: '8px',
                        fontWeight: '600',
                        padding: '6px 12px',
                        fontSize: '11px'
                      }}
                    >
                      🗑️ Limpiar
                    </Button>
                  </div>
                </div>

                <Row className="gy-3">
                  <Col xs={12} lg={6}>
                    <FormGroup>
                      <Label className="fw-bold text-dark mb-2 d-flex align-items-center">
                        <span className="me-2">🏛️</span>
                        Entidad
                      </Label>
                     
                      <CustomDropdown
                        isOpen={dropdownEntidad}
                        toggle={(e) => {
                          if (e && e.target) {
                            const isInputArea = e.target.tagName === 'INPUT' || 
                                               e.target.closest('.p-3.border-bottom.bg-light') ||
                                               e.target.classList.contains('form-control-sm');
                            
                            if (isInputArea) {
                              return;
                            }
                          }
                          
                          setDropdownEntidad(!dropdownEntidad);
                        }}
                        buttonText={entidadHandlers.getButtonText(entidadesUnicas)}
                        items={entidadesUnicas}
                        filteredItems={entidadesFiltradas}
                        selectedItems={entidadesSeleccionadas}
                        searchValue={searchEntidad}
                        setSearchValue={setSearchEntidad}
                        handlers={entidadHandlers}
                        dropdownRef={dropdownEntidadRef}
                        placeholder="🔍 Buscar entidad..."
                        icon="🏛️"
                      />
                    </FormGroup>
                  </Col>

                  <Col xs={12} lg={6}>
                    <FormGroup>
                      <Label className="fw-bold text-dark mb-2 d-flex align-items-center">
                        <span className="me-2">🏷️</span>
                        Nomenclatura
                      </Label>
                      <InputGroup style={{ borderRadius: '12px', overflow: 'hidden' }}>
                        <InputGroupText style={{ 
                          backgroundColor: '#e9ecef', 
                          border: '2px solid #e9ecef',
                          borderRight: 'none',
                          fontSize: '1rem'
                        }}>
                          📝
                        </InputGroupText>
                        <Input
                          type="text"
                          placeholder="Ej: AS-1-2024"
                          value={filtroNomenclatura}
                          onChange={(e) => setFiltroNomenclatura(e.target.value)}
                          style={{
                            border: '2px solid #e9ecef',
                            borderLeft: 'none',
                            borderRadius: '0 12px 12px 0',
                            fontSize: '14px',
                            fontWeight: '500',
                            padding: '12px 16px'
                          }}
                        />
                      </InputGroup>
                    </FormGroup>
                  </Col>

                  <Col xs={12} lg={6}>
                    <FormGroup>
                      <Label className="fw-bold text-dark mb-2 d-flex align-items-center">
                        <span className="me-2">📝</span>
                        Descripción Proceso
                      </Label>
                      <InputGroup style={{ borderRadius: '12px', overflow: 'hidden' }}>
                        <InputGroupText style={{ 
                          backgroundColor: '#e9ecef', 
                          border: '2px solid #e9ecef',
                          borderRight: 'none',
                          fontSize: '1rem'
                        }}>
                          🔍
                        </InputGroupText>
                        <Input
                          type="text"
                          placeholder="Ej: contratación, servicios..."
                          value={filtroDescripcion}
                          onChange={(e) => setFiltroDescripcion(e.target.value)}
                          style={{
                            border: '2px solid #e9ecef',
                            borderLeft: 'none',
                            borderRadius: '0 12px 12px 0',
                            fontSize: '14px',
                            fontWeight: '500',
                            padding: '12px 16px'
                          }}
                        />
                      </InputGroup>
                    </FormGroup>
                  </Col>

                  <Col xs={12} lg={6}>
                    <FormGroup>
                      <Label className="fw-bold text-dark mb-2 d-flex align-items-center">
                        <span className="me-2">⚙️</span>
                        Tipo de Proceso
                      </Label>
                      <Input
                        type="select"
                        value={filtroTipoProceso}
                        onChange={(e) => setFiltroTipoProceso(e.target.value)}
                        style={{
                          borderRadius: '12px',
                          border: '2px solid #e9ecef',
                          fontSize: '14px',
                          fontWeight: '500',
                          padding: '12px 16px',
                          backgroundColor: '#f8f9fa'
                        }}
                      >
                        <option value="">📋 Todos los tipos</option>
                        {tiposProcesoUnicos.map((tipo) => (
                          <option key={tipo} value={tipo}>{tipo}</option>
                        ))}
                      </Input>
                    </FormGroup>
                  </Col>

                  <Col xs={12} lg={6}>
                    <FormGroup>
                      <Label className="fw-bold text-dark mb-2 d-flex align-items-center">
                        <span className="me-2">📦</span>
                        Objeto Contractual
                      </Label>
                      <Input
                        type="select"
                        value={filtroObjeto}
                        onChange={(e) => setFiltroObjeto(e.target.value)}
                        style={{
                          borderRadius: '12px',
                          border: '2px solid #e9ecef',
                          fontSize: '14px',
                          fontWeight: '500',
                          padding: '12px 16px',
                          backgroundColor: '#f8f9fa'
                        }}
                      >
                        <option value="">📋 Todos los objetos</option>
                        {objetosUnicos.map((objeto) => (
                          <option key={objeto} value={objeto}>{objeto}</option>
                        ))}
                      </Input>
                    </FormGroup>
                  </Col>

                  <Col xs={12} lg={6}>
  <FormGroup>
    <Label className="fw-bold text-dark mb-2 d-flex align-items-center">
      <span className="me-2">📊</span>
      Estado de Revisión
    </Label>
    <Input
      type="select"
      value={filtroEstadoRevision}
      onChange={(e) => setFiltroEstadoRevision(e.target.value)}
      style={{
        borderRadius: '12px',
        border: '2px solid #e9ecef',
        fontSize: '14px',
        fontWeight: '500',
        padding: '12px 16px',
        backgroundColor: '#f8f9fa'
      }}
    >
      <option value="todos">📋 Mostrar todos</option>
      <option value="pendientes">⏳ Solo mostrar pendientes</option>
      <option value="revisados">✅ Solo mostrar revisados</option>
    </Input>
  </FormGroup>
</Col>

                  <Col xs={12} lg={6}>
                    <FormGroup>
                      <Label className="fw-bold text-dark mb-2 d-flex align-items-center">
                        <span className="me-2">🗺️</span>
                        Departamento
                      </Label>
                      <Input
                        type="select"
                        value={filtroDepartamento}
                        onChange={(e) => setFiltroDepartamento(e.target.value)}
                        style={{
                          borderRadius: '12px',
                          border: '2px solid #e9ecef',
                          fontSize: '14px',
                          fontWeight: '500',
                          padding: '12px 16px',
                          backgroundColor: '#f8f9fa'
                        }}
                      >
                        <option value="">📋 Todos los departamentos</option>
                        {departamentosUnicos.map((departamento) => (
                          <option key={departamento} value={departamento}>{departamento}</option>
                        ))}
                      </Input>
                    </FormGroup>
                  </Col>

                  <Col xs={12} lg={6}>
                    <FormGroup>
                      <Label className="fw-bold text-dark mb-2 d-flex align-items-center">
                        <span className="me-2">🏘️</span>
                        Provincia
                      </Label>
                      <Input
                        type="select"
                        value={filtroProvincia}onChange={(e) => setFiltroProvincia(e.target.value)}
                       style={{
                         borderRadius: '12px',
                         border: '2px solid #e9ecef',
                         fontSize: '14px',
                         fontWeight: '500',
                         padding: '12px 16px',
                         backgroundColor: '#f8f9fa'
                       }}
                     >
                       <option value="">📋 Todas las provincias</option>
                       {provinciasUnicas.map((provincia) => (
                         <option key={provincia} value={provincia}>{provincia}</option>
                       ))}
                     </Input>
                   </FormGroup>
                 </Col>

               </Row>
             </CardBody>
           </Card>
         </Collapse>

         {/* Contenido Principal */}
         <Card className="shadow-sm border-0" style={{ borderRadius: '16px' }}>
           <CardBody className="p-0">
             {dataPaginada.length > 0 ? (
               <>
                 {/* Vista de tabla para desktop */}
                 {!isMobile && (
                   <div style={{ 
                     overflowX: 'auto',
                     borderRadius: '16px 16px 0 0'
                   }}>
                     <Table responsive hover className="mb-0" style={{ fontSize: '14px' }}>
                       <thead style={{ 
                         background: 'linear-gradient(135deg, #28a745 0%, #20c997 100%)',
                         color: 'white'
                       }}>
                         <tr>
                        {[
  { key: 'estado', label: 'REVISADO', width: '100px' },
  { key: 'nomenclatura', label: 'NOMENCLATURA', width: '130px' },
  { key: 'departamento', label: 'DEPARTAMENTO', width: '150px' },
{ key: 'provincia', label: 'PROVINCIA', width: '150px' },
{ key: 'distrito', label: 'DISTRITO', width: '150px' },
{ key: 'entidad', label: 'ENTIDAD', width: '250px' },
  { key: 'descripcion_proceso', label: 'DESCRIPCIÓN PROCESO', width: '300px' },
  { key: 'objet', label: 'OBJETO', width: '120px' },
  { key: 'tipo_proceso', label: 'TIPO PROCESO', width: '150px' },
  { key: 'total_items', label: 'TOTAL ITEMS', width: '100px' },
  { key: 'fecha_inicio_participantes', label: 'F. INICIO REGISTRO', width: '110px' },
  { key: 'fecha_fin_participantes', label: 'F. FIN REGISTRO', width: '110px' },
  { key: 'fecha_presentacion_propuestas', label: 'F. PRESENTACIÓN', width: '130px' }
                           ].map((col) => (
                             
                             <th
                               key={col.key} 
                               onClick={() => handleSort(col.key)}
                               style={{ 
                                 cursor: 'pointer', 
                                 userSelect: 'none',
                                 fontWeight: '700',
                                 fontSize: '13px',
                                 textTransform: 'uppercase',
                                 letterSpacing: '0.5px',
                                 padding: '16px 12px',
                                 borderBottom: 'none',
                                 minWidth: col.width,
                                 position: 'sticky',
                                 top: 0,
                                 zIndex: 10,
                                 background: 'linear-gradient(135deg, #28a745 0%, #20c997 100%)'
                               }}
                               className="text-white"
                             >
                               <div className="d-flex align-items-center justify-content-between">
                                 <span>{col.label}</span>
                                 <span style={{ 
                                   fontSize: '16px', 
                                   marginLeft: '8px',
                                   opacity: sortConfig.key === col.key ? 1 : 0.5
                                 }}>
                                   {getSortIcon(col.key)}
                                 </span>
                               </div>
                             </th>
                           ))}
                           <th 
                             className="text-center text-white"
                             style={{
                               fontWeight: '700',
                               fontSize: '13px',
                               textTransform: 'uppercase',
                               letterSpacing: '0.5px',
                               padding: '16px 12px',
                               borderBottom: 'none',
                               width: '120px',
                               position: 'sticky',
                               top: 0,
                               zIndex: 10,
                               background: 'linear-gradient(135deg, #28a745 0%, #20c997 100%)'
                             }}
                           >
                             ACCIONES
                           </th>
                           
                         </tr>
                       </thead>
                       <tbody>
                        
                         {dataPaginada.map((proceso, index) => (
                           <tr 
                             key={`${proceso.nomenclatura}-${proceso.descripcion_proceso}-${index}`}
                             
                             style={{
                               backgroundColor: isProcessReviewed(proceso) 
                                 ? '#f8fff8' 
                                 : (index % 2 === 0 ? '#ffffff' : '#f8f9fa'),
                               transition: 'all 0.3s ease',
                               borderLeft: isProcessReviewed(proceso) ? '4px solid #28a745' : 'none'
                             }}
                             onMouseEnter={(e) => {
                               e.currentTarget.style.backgroundColor = '#e8f5e8';
                               e.currentTarget.style.transform = 'translateY(-1px)';
                               e.currentTarget.style.boxShadow = '0 4px 12px rgba(0,0,0,0.1)';
                             }}
                             onMouseLeave={(e) => {
                               e.currentTarget.style.backgroundColor = isProcessReviewed(proceso) 
                                 ? '#f8fff8' 
                                 : (index % 2 === 0 ? '#ffffff' : '#f8f9fa');
                               e.currentTarget.style.transform = 'translateY(0)';
                               e.currentTarget.style.boxShadow = 'none';
                             }}
                           >
                            {/* ESTADO - PRIMERA COLUMNA */}
<td className="text-center" style={{ 
  padding: '16px 12px',
  borderBottom: '1px solid #e9ecef'
}}>
  <ReviewCheckbox 
    process={proceso} 
    user={user}
    className="justify-content-center"
  />
</td>
                             {/* NOMENCLATURA */}
                             <td style={{ 
                               padding: '16px 12px',
                               fontWeight: '500',
                               color: '#6f42c1',
                               borderBottom: '1px solid #e9ecef'
                             }}>
                               <div style={{
                                 wordWrap: 'break-word',
                                 whiteSpace: 'normal',
                                 lineHeight: '1.4'
                               }}>
                                 {proceso.nomenclatura || '-'}
                               </div>
                             </td>

                             {/* DEPARTAMENTO */}
                             <td style={{ padding: '16px 12px', borderBottom: '1px solid #e9ecef' }}>
                               <span className="fw-medium text-dark">{proceso.departamento || '-'}</span>
                             </td>

                             {/* PROVINCIA */}
                             <td style={{ padding: '16px 12px', borderBottom: '1px solid #e9ecef' }}>
                               <span className="fw-medium text-dark">{proceso.provincia || '-'}</span>
                             </td>

                          {/* DISTRITO */}
<td style={{ padding: '16px 12px', borderBottom: '1px solid #e9ecef' }}>
  <span className="fw-medium text-dark">{proceso.distrito || '-'}</span>
</td>
                             {/* ENTIDAD */}
                             <td style={{ 
                               padding: '16px 12px',
                               borderBottom: '1px solid #e9ecef'
                             }}>
                               <div style={{
                                 wordWrap: 'break-word',
                                 whiteSpace: 'normal',
                                 fontWeight: '500',
                                 color: '#495057',
                                 lineHeight: '1.4',
                                 maxWidth: '250px'
                               }}>
                                 {proceso.entidad || '-'}
                               </div>
                             </td>

                             {/* DESCRIPCIÓN PROCESO */}
                             <td style={{ 
                               padding: '16px 12px',
                               borderBottom: '1px solid #e9ecef'
                             }}>
                               <div 
                                 style={{
                                   wordWrap: 'break-word',
                                   whiteSpace: 'normal',
                                   fontWeight: '500',
                                   color: '#495057',
                                   lineHeight: '1.4',
                                   maxWidth: '300px',
                                   maxHeight: '60px',
                                   overflow: 'hidden',
                                   textOverflow: 'ellipsis',
                                   cursor: proceso.descripcion_proceso ? 'help' : 'default'
                                 }}
                                 title={proceso.descripcion_proceso || 'Sin descripción'}
                                 onMouseEnter={(e) => {
                                   if (proceso.descripcion_proceso && proceso.descripcion_proceso.length > 50) {
                                     handleMouseEnterDescription(e, proceso.descripcion_proceso);
                                   }
                                 }}
                                 onMouseLeave={handleMouseLeaveDescription}
                               >
                                 {proceso.descripcion_proceso || 'Sin descripción'}
                               </div>
                             </td>

                             {/* OBJETO */}
                             <td style={{ 
                               padding: '16px 12px',
                               borderBottom: '1px solid #e9ecef'
                             }}>
                               <Badge 
                                 color={getTypeColor(proceso.objet)}
                                 style={{
                                   fontSize: '11px',
                                   fontWeight: '600',
                                   padding: '6px 12px',
                                   borderRadius: '20px',
                                   textTransform: 'uppercase',
                                   letterSpacing: '0.5px'
                                 }}
                               >
                                 {proceso.objet || 'N/A'}
                               </Badge>
                             </td>

                             {/* TIPO PROCESO */}
                             <td style={{ 
                               padding: '16px 12px',
                               borderBottom: '1px solid #e9ecef'
                             }}>
                               <Badge 
                                 color={getTypeColor(proceso.tipo_proceso)}
                                 style={{
                                   fontSize: '11px',
                                   fontWeight: '600',
                                   padding: '6px 12px',
                                   borderRadius: '20px',
                                   textTransform: 'uppercase',
                                   letterSpacing: '0.5px'
                                 }}
                               >
                                 {proceso.tipo_proceso || 'N/A'}
                               </Badge>
                             </td>

                             {/* TOTAL ITEMS */}
                             <td style={{ 
                               padding: '16px 12px',
                               fontWeight: '600',
                               color: '#28a745',
                               borderBottom: '1px solid #e9ecef',
                               textAlign: 'center'
                             }}>
                               <Badge 
                                 color="success"
                                 style={{
                                   fontSize: '12px',
                                   fontWeight: '700',
                                   padding: '8px 12px',
                                   borderRadius: '20px'
                                 }}
                               >
                                 {proceso.total_items}
                               </Badge>
                             </td>

                             {/* F. INICIO REGISTRO */}
                             <td style={{ 
                               padding: '16px 12px',
                               fontWeight: '500',
                               color: '#495057',
                               borderBottom: '1px solid #e9ecef'
                             }}>
                               {formatDateFromSupabase(proceso.fecha_inicio_participantes)}
                             </td>

                             {/* F. FIN REGISTRO */}
                             <td style={{ 
                               padding: '16px 12px',
                               fontWeight: '500',
                               color: '#495057',
                               borderBottom: '1px solid #e9ecef'
                             }}>
                               {formatDateFromSupabase(proceso.fecha_fin_participantes)}
                             </td>

                             {/* F. PRESENTACIÓN */}
                             <td style={{ 
                               padding: '16px 12px',
                               fontWeight: '500',
                               color: '#495057',
                               borderBottom: '1px solid #e9ecef'
                             }}>
                               {formatDateFromSupabase(proceso.fecha_presentacion_propuestas)}
                             </td>

                             {/* ACCIONES */}
                             <td className="text-center" style={{ 
                               padding: '16px 12px',
                               borderBottom: '1px solid #e9ecef'
                             }}>
                               <Button
                                 color="success"
                                 size="sm"
                                 onClick={() => openModal(proceso)}
                                 title="Ver detalles completos"
                                 style={{
                                   borderRadius: '8px',
                                   fontWeight: '600',
                                   padding: '8px 12px',
                                   fontSize: '12px',
                                   border: 'none',
                                   boxShadow: '0 2px 8px rgba(40,167,69,0.3)',
                                   transition: 'all 0.2s ease'
                                 }}
                               >
                                 Ver
                               </Button>
                             </td>

                            
                           </tr>
                         ))}
                       </tbody>
                     </Table>
                   </div>
                 )}
                 
                 {/* Vista de tarjetas para móvil */}
                 {isMobile && (
                   <div className="p-3">
                     {dataPaginada.map((proceso, index) => (
                       <MobileProcessCard key={`${proceso.nomenclatura}-${index}`} proceso={proceso} index={index} />
                     ))}
                   </div>
                 )}
                
                <div className="px-4 pb-4 bg-light" style={{ borderRadius: '0 0 16px 16px' }}>
                  <PaginationComponent />
                </div>
              </>
            ) : (
              <div className="text-center py-5">
                <div className="mb-4" style={{ fontSize: '4rem', opacity: 0.3 }}>📄</div>
                <h4 className="text-muted mb-3 fw-bold" style={{ fontSize: isMobile ? '1.2rem' : '1.5rem' }}>
                  No se encontraron procesos nuevos
                </h4>
               
                <p className="text-muted mb-4" style={{ fontSize: isMobile ? '0.9rem' : '1.1rem' }}>
                  Intenta ajustar los filtros de búsqueda para encontrar más resultados
                </p>
                <Button 
                  color="success" 
                  onClick={clearFilters}
                  size={isMobile ? 'sm' : ''}
                  style={{
                    borderRadius: '12px',
                    fontWeight: '600',
                    padding: isMobile ? '8px 16px' : '12px 24px',
                    fontSize: isMobile ? '12px' : '14px',
                    border: 'none',
                    boxShadow: '0 4px 12px rgba(40,167,69,0.3)'
                  }}
                >
                  Limpiar Todos los Filtros
                </Button>
              </div>
            )}
          </CardBody>
        </Card>
      </>
    )}

    {/* Modal de Detalles */}
    <Modal 
      isOpen={modalOpen} 
      toggle={closeModal} 
      size={isMobile ? 'lg' : 'xl'}
      backdrop="static"
      keyboard={false}
      style={{ zIndex: 1050 }}
    >
      <ModalHeader 
        toggle={closeModal} 
        className="border-0 pb-0"
        style={{
          background: 'linear-gradient(135deg, #28a745 0%, #20c997 100%)',
          color: 'white',
          borderRadius: '20px 20px 0 0'
        }}
      >
        <div className="d-flex align-items-center">
          <div className="me-2" style={{ fontSize: isMobile ? '2rem' : '2.5rem' }}>
            🆕
          </div>
          <div>
            <h4 className="mb-1 fw-bold text-white" style={{ fontSize: isMobile ? '1.2rem' : '1.5rem' }}>
              Detalles del Proceso SEACE
            </h4>
            <p className="mb-0 text-white-50" style={{ fontSize: isMobile ? '0.8rem' : '1rem' }}>
              {selectedProcess?.nomenclatura || 'Sin nomenclatura disponible'} • {selectedProcess?.total_items || 0} items
            </p>
          </div>
        </div>
      </ModalHeader>
      
      <ModalBody className={`p-${isMobile ? '3' : '4'}`} style={{ backgroundColor: '#f8f9fa' }}>
        {selectedProcess && (
          <Row className="gy-3">
            {/* Información General */}
            <Col xs={12} md={6}>
              <Card className="h-100 border-0 shadow-sm" style={{ borderRadius: '12px' }}>
                <CardBody className={`p-${isMobile ? '3' : '4'}`}>
                  <h6 className="fw-bold mb-3 d-flex align-items-center" style={{ color: '#20c997', fontSize: isMobile ? '1rem' : '1.1rem' }}>
                    <span className="me-2" style={{ fontSize: '1.2rem' }}>ℹ️</span>
                    Información General
                  </h6>
                  <div className="space-y-2">
                    <div className="d-flex justify-content-between align-items-center py-2 border-bottom border-light">
                      <strong className="text-muted" style={{ fontSize: isMobile ? '12px' : '14px' }}>Nomenclatura:</strong>
                      <span className="fw-bold text-primary" style={{ fontSize: isMobile ? '12px' : '14px' }}>{selectedProcess.nomenclatura || '-'}</span>
                    </div>
                    <div className="d-flex justify-content-between align-items-center py-2 border-bottom border-light">
                      <strong className="text-muted" style={{ fontSize: isMobile ? '12px' : '14px' }}>Departamento:</strong>
                      <span className="fw-medium text-dark" style={{ fontSize: isMobile ? '12px' : '14px' }}>{selectedProcess.departamento || '-'}</span>
                    </div>
                    
                    <div className="d-flex justify-content-between align-items-center py-2 border-bottom border-light">
                      <strong className="text-muted" style={{ fontSize: isMobile ? '12px' : '14px' }}>Provincia:</strong>
                      <span className="fw-medium text-dark" style={{ fontSize: isMobile ? '12px' : '14px' }}>{selectedProcess.provincia || '-'}</span>
                    </div>
                    
                    
                    <div className="d-flex justify-content-between align-items-center py-2 border-bottom border-light">
                      <strong className="text-muted" style={{ fontSize: isMobile ? '12px' : '14px' }}>Tipo de Proceso:</strong>
                      <Badge 
                        color={getTypeColor(selectedProcess.tipo_proceso)}
                        style={{
                          fontSize: isMobile ? '10px' : '12px',
                          fontWeight: '600',
                          padding: '4px 8px',
                          borderRadius: '12px'
                        }}
                      >
                        {selectedProcess.tipo_proceso || 'N/A'}
                      </Badge>
                    </div>
                    <div className="d-flex justify-content-between align-items-center py-2 border-bottom border-light">
                      <strong className="text-muted" style={{ fontSize: isMobile ? '12px' : '14px' }}>Total Items:</strong>
                      <Badge 
                        color="success"
                        style={{
                          fontSize: isMobile ? '10px' : '12px',
                          fontWeight: '600',
                          padding: '4px 8px',
                          borderRadius: '12px'
                        }}
                      >
                        {selectedProcess.total_items || 0}
                      </Badge>
                    </div>
                    
                    <div className="d-flex justify-content-between align-items-center py-2">
                      <strong className="text-muted" style={{ fontSize: isMobile ? '12px' : '14px' }}>Fecha Creación:</strong>
                      <span className="fw-medium text-dark" style={{ fontSize: isMobile ? '12px' : '14px' }}>{formatDateFromSupabase(selectedProcess.created_at)}</span>
                    </div>
                  </div>
                </CardBody>
              </Card>
            </Col>

            {/* Información de la Entidad */}
            <Col xs={12} md={6}>
              <Card className="h-100 border-0 shadow-sm" style={{ borderRadius: '12px' }}>
                <CardBody className={`p-${isMobile ? '3' : '4'}`}>
                  <h6 className="fw-bold mb-3 d-flex align-items-center" style={{ color: '#28a745', fontSize: isMobile ? '1rem' : '1.1rem' }}>
                    <span className="me-2" style={{ fontSize: '1.2rem' }}>🏢</span>
                    Información de la Entidad
                  </h6>
                  <div className="space-y-2">
                    <div className="d-flex justify-content-between align-items-start py-2 border-bottom border-light">
                      <strong className="text-muted" style={{ fontSize: isMobile ? '12px' : '14px' }}>Entidad:</strong>
                      <span className="fw-medium text-dark text-end" style={{ maxWidth: '60%', fontSize: isMobile ? '12px' : '14px' }}>
                        {selectedProcess.entidad || '-'}
                      </span>
                    </div>
                    <div className="d-flex justify-content-between align-items-center py-2 border-bottom border-light">
                      <strong className="text-muted" style={{ fontSize: isMobile ? '12px' : '14px' }}>Objeto Contractual:</strong>
                      <Badge 
                        color={getTypeColor(selectedProcess.objet)}
                        style={{
                          fontSize: isMobile ? '10px' : '12px',
                          fontWeight: '600',
                          padding: '4px 8px',
                          borderRadius: '12px'
                        }}
                      >
                        {selectedProcess.objet || 'N/A'}
                      </Badge>
                    </div>
                    <div className="d-flex justify-content-between align-items-center py-2">
                      <strong className="text-muted" style={{ fontSize: isMobile ? '12px' : '14px' }}>Moneda:</strong>
                      <Badge 
                        color={getMonedaColor(selectedProcess.moneda)}
                        style={{
                          fontSize: isMobile ? '10px' : '12px',
                          fontWeight: '600',
                          padding: '4px 8px',
                          borderRadius: '12px'
                        }}
                      >
                        {selectedProcess.moneda || 'N/A'}
                      </Badge>
                    </div>
                  </div>
                </CardBody>
              </Card>
            </Col>

            {/* Fechas del Proceso */}
            <Col xs={12}>
              <Card className="border-0 shadow-sm" style={{ borderRadius: '12px' }}>
                <CardBody className={`p-${isMobile ? '3' : '4'}`}>
                  <h6 className="fw-bold mb-3 d-flex align-items-center" style={{ color: '#ffc107', fontSize: isMobile ? '1rem' : '1.1rem' }}>
                    <span className="me-2" style={{ fontSize: '1.2rem' }}>📅</span>
                    CRONOGRAMA
                  </h6>
                  <Row className="gy-2">
                    <Col xs={12} md={6}>
                      <div className="d-flex justify-content-between align-items-center py-2 border-bottom border-light">
                        <strong className="text-muted" style={{ fontSize: isMobile ? '12px' : '14px' }}>Fecha de Convocatoria:</strong>
                        <span className="fw-medium text-dark" style={{ fontSize: isMobile ? '12px' : '14px' }}>{formatDateFromSupabase(selectedProcess.fecha_convocatoria)}</span>
                      </div>
                    </Col>
                    <Col xs={12} md={6}>
                      <div className="d-flex justify-content-between align-items-center py-2 border-bottom border-light">
                        <strong className="text-muted" style={{ fontSize: isMobile ? '12px' : '14px' }}>Fecha Presentación Propuestas:</strong>
                        <span className="fw-medium text-dark" style={{ fontSize: isMobile ? '12px' : '14px' }}>{formatDateFromSupabase(selectedProcess.fecha_presentacion_propuestas)}</span>
                      </div>
                    </Col>
                    <Col xs={12} md={6}>
                      <div className="d-flex justify-content-between align-items-center py-2 border-bottom border-light">
                        <strong className="text-muted" style={{ fontSize: isMobile ? '12px' : '14px' }}>Fecha Inicio Participantes:</strong>
                        <span className="fw-medium text-dark" style={{ fontSize: isMobile ? '12px' : '14px' }}>{formatDateFromSupabase(selectedProcess.fecha_inicio_participantes)}</span>
                      </div>
                    </Col>
                    <Col xs={12} md={6}>
                      <div className="d-flex justify-content-between align-items-center py-2">
                        <strong className="text-muted" style={{ fontSize: isMobile ? '12px' : '14px' }}>Fecha Fin Participantes:</strong>
                        <span className="fw-bold text-warning" style={{ fontSize: isMobile ? '12px' : '14px' }}>{formatDateFromSupabase(selectedProcess.fecha_fin_participantes)}</span>
                      </div>
                    </Col>
                  </Row>
                </CardBody>
              </Card>
            </Col>

            {/* Descripción Completa */}
            <Col xs={12}>
              <Card className="border-0 shadow-sm" style={{ borderRadius: '12px' }}>
                <CardBody className={`p-${isMobile ? '3' : '4'}`}>
                  <h6 className="fw-bold mb-3 d-flex align-items-center" style={{ color: '#6f42c1', fontSize: isMobile ? '1rem' : '1.1rem' }}>
                    <span className="me-2" style={{ fontSize: '1.2rem' }}>📝</span>
                    Descripción de la convocatoria
                  </h6>
                  <div 
                    className={`p-${isMobile ? '3' : '4'} rounded-3`}
                    style={{ 
                      backgroundColor: '#ffffff', 
                      border: '2px solid #e9ecef',
                      boxShadow: 'inset 0 2px 4px rgba(0,0,0,0.05)'
                    }}
                  >
                    <p className="mb-0 text-dark" style={{ 
                      lineHeight: '1.7', 
                      fontSize: isMobile ? '13px' : '15px',
                      fontWeight: '500'
                    }}>
                      {selectedProcess.descripcion_proceso || 'No hay descripción disponible para este proceso'}
                    </p>
                  </div>
                </CardBody></Card>
            </Col>

            {/* Lista de Items del Proceso */}
            <Col xs={12}>
              <Card className="border-0 shadow-sm" style={{ borderRadius: '12px' }}>
                <CardBody className={`p-${isMobile ? '3' : '4'}`}>
                  <h6 className="fw-bold mb-3 d-flex align-items-center justify-content-between" style={{ color: '#fd7e14', fontSize: isMobile ? '1rem' : '1.1rem' }}>
                    <div className="d-flex align-items-center">
                      <span className="me-2" style={{ fontSize: '1.2rem' }}>📦</span>
                      Items del Proceso
                    </div>
                    <Badge 
                      color="warning" 
                      style={{
                        fontSize: isMobile ? '10px' : '12px',
                        fontWeight: '600',
                        padding: '4px 8px',
                        borderRadius: '12px'
                      }}
                    >
                      {selectedProcess.items?.length || 0} items
                    </Badge>
                  </h6>
                  
                  {selectedProcess.items && selectedProcess.items.length > 0 ? (
                    <div style={{ maxHeight: isMobile ? '300px' : '400px', overflowY: 'auto' }}>
                      {isMobile ? (
                        // Vista de tarjetas para móvil
                        <div className="d-grid gap-2">
                          {selectedProcess.items.map((item, index) => (
                            <Card key={index} className="border-0" style={{ backgroundColor: '#fff3cd' }}>
                              <CardBody className="p-3">
                                <div className="d-flex justify-content-between align-items-start mb-2">
                                  <Badge color="warning" style={{ fontSize: '10px' }}>
                                    ID: {item.id_procedimiento || '-'}
                                  </Badge>
                                  <small className="text-muted">
                                    {formatDateFromSupabase(item.created_at)}
                                  </small>
                                </div>
                                <p className="mb-0" style={{ fontSize: '12px', lineHeight: '1.4' }}>
                                  {item.detalle_item || 'Sin detalle'}
                                </p>
                              </CardBody>
                            </Card>
                          ))}
                        </div>
                      ) : (
                        // Vista de tabla para desktop
                        <Table responsive className="mb-0" style={{ fontSize: '13px' }}>
                          <thead style={{ backgroundColor: '#fff3cd', borderRadius: '8px' }}>
                            <tr>
                              <th style={{ 
                                padding: '12px', 
                                fontWeight: '700', 
                                color: '#856404',
                                border: 'none',
                                fontSize: '12px',
                                textTransform: 'uppercase'
                              }}>
                                ID Procedimiento
                              </th>
                              <th style={{ 
                                padding: '12px', 
                                fontWeight: '700', 
                                color: '#856404',
                                border: 'none',
                                fontSize: '12px',
                                textTransform: 'uppercase'
                              }}>
                                Detalle del Item
                              </th>
                              <th style={{ 
                                padding: '12px', 
                                fontWeight: '700', 
                                color: '#856404',
                                border: 'none',
                                fontSize: '12px',
                                textTransform: 'uppercase',
                                textAlign: 'center'
                              }}>
                                Fecha Creación
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            {selectedProcess.items.map((item, index) => (
                              <tr 
                                key={index}
                                style={{
                                  backgroundColor: index % 2 === 0 ? '#ffffff' : '#fffbf0',
                                  transition: 'background-color 0.2s ease'
                                }}
                                onMouseEnter={(e) => {
                                  e.currentTarget.style.backgroundColor = '#fff3cd';
                                }}
                                onMouseLeave={(e) => {
                                  e.currentTarget.style.backgroundColor = index % 2 === 0 ? '#ffffff' : '#fffbf0';
                                }}
                              >
                                <td style={{ 
                                  padding: '12px', 
                                  fontWeight: '600',
                                  color: '#fd7e14',
                                  borderBottom: '1px solid #f8f9fa',
                                  textAlign: 'center'
                                }}>
                                  {item.id_procedimiento || '-'}
                                </td>
                                <td style={{ 
                                  padding: '12px',
                                  color: '#495057',
                                  borderBottom: '1px solid #f8f9fa',
                                  lineHeight: '1.5'
                                }}>
                                  {item.detalle_item || 'Sin detalle'}
                                </td>
                                <td style={{ 
                                  padding: '12px',
                                  color: '#6c757d',
                                  borderBottom: '1px solid #f8f9fa',
                                  textAlign: 'center',
                                  fontWeight: '500'
                                }}>
                                  {formatDateFromSupabase(item.created_at)}
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </Table>
                      )}
                    </div>
                  ) : (
                    <div className="text-center py-4">
                      <div className="mb-3" style={{ fontSize: '2rem', opacity: 0.3 }}>📦</div>
                      <p className="text-muted mb-0" style={{ fontSize: isMobile ? '12px' : '14px' }}>
                        No hay items registrados para este proceso
                      </p>
                    </div>
                  )}
                </CardBody>
              </Card>
            </Col>
          </Row>
        )}
      </ModalBody>
      
      <ModalFooter 
        className="border-0 pt-0" 
        style={{ 
          backgroundColor: '#f8f9fa',
          borderRadius: '0 0 20px 20px'
        }}
      >
        <div className="d-flex gap-2 w-100 justify-content-end">
          <Button 
            color="secondary" 
            onClick={closeModal}
            size={isMobile ? 'sm' : ''}
            style={{
              borderRadius: '10px',
              fontWeight: '600',
              padding: isMobile ? '8px 16px' : '10px 20px',
              fontSize: isMobile ? '12px' : '14px',
              border: 'none',
              backgroundColor: '#6c757d',
              boxShadow: '0 2px 8px rgba(108,117,125,0.3)'
            }}
          >
            <span className="me-1">🚪</span>
            Cerrar
          </Button>
          
          <Button 
            color="success"
            size={isMobile ? 'sm' : ''}
            onClick={() => {
              const itemsInfo = selectedProcess?.items?.map((item, index) => 
                `${index + 1}. ID: ${item.id_procedimiento} - ${item.detalle_item} - Fecha: ${formatDateFromSupabase(item.created_at)}`
              ).join('\n') || 'Sin items';
              
              const info = `
SEACE NUEVOS - Proceso de Contratación
Nomenclatura: ${selectedProcess?.nomenclatura || '-'}
Entidad: ${selectedProcess?.entidad || '-'}
Tipo de Proceso: ${selectedProcess?.tipo_proceso || '-'}
Número de Proceso: ${selectedProcess?.num_proceso || '-'}
Objeto Contractual: ${selectedProcess?.objet || '-'}
Moneda: ${selectedProcess?.moneda || '-'}
Departamento: ${selectedProcess?.departamento || '-'}
Provincia: ${selectedProcess?.provincia || '-'}
Distrito: ${selectedProcess?.distrito || '-'}
Total Items: ${selectedProcess?.total_items || 0}
Fecha de Convocatoria: ${formatDateFromSupabase(selectedProcess?.fecha_convocatoria)}
Fecha Presentación Propuestas: ${formatDateFromSupabase(selectedProcess?.fecha_presentacion_propuestas)}
Fecha Inicio Participantes: ${formatDateFromSupabase(selectedProcess?.fecha_inicio_participantes)}
Fecha Fin Participantes: ${formatDateFromSupabase(selectedProcess?.fecha_fin_participantes)}
Descripción: ${selectedProcess?.descripcion_proceso || '-'}

ITEMS DEL PROCESO:
${itemsInfo}
              `.trim();
              
              navigator.clipboard.writeText(info).then(() => {
                console.log('Información copiada al portapapeles');
              }).catch(err => {
                console.error('Error al copiar:', err);
              });
            }}
            style={{
              borderRadius: '10px',
              fontWeight: '600',
              padding: isMobile ? '8px 16px' : '10px 20px',
              fontSize: isMobile ? '12px' : '14px',
              border: 'none',
              backgroundColor: '#28a745',
              boxShadow: '0 2px 8px rgba(40,167,69,0.3)'
            }}
          >
            <span className="me-1">📋</span>
            Copiar Info
          </Button>
        </div>
      </ModalFooter>
    </Modal>
  </Container>
);};

export default SEACENuevos;